import React, { memo, useMemo } from 'react';
import { Image as Img, useWindowDimensions, View, } from 'react-native';
/**
 * Primary UI component for user interaction
 */
const RewardStructure = ({ title }) => {
    const BreakPoint = {
        Web: 1024,
    };
    const { width } = useWindowDimensions();
    const _isMobile = width < BreakPoint.Web ? true : false;
    const _child = useMemo(() => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    backgroundColor: '#F1F3F5',
                    paddingLeft: 24,
                    paddingRight: 24,
                    width: '100%',
                    borderRadius: 8,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                } },
                React.createElement(Img, { source: {
                        uri: _isMobile
                            ? 'https://volt-images.s3.ap-south-1.amazonaws.com/rewardStructureMobNew2.png'
                            : 'https://volt-images.s3.ap-south-1.amazonaws.com/rewardStructureNew1.png',
                    }, resizeMode: 'contain', style: {
                        width: _isMobile ? 328 : 700,
                        height: _isMobile ? 350 : 231,
                    } }))));
    }, [_isMobile]);
    return React.createElement(React.Fragment, null, _child);
};
export default memo(RewardStructure);
export { RewardStructure };
